import { Button, Stack, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import banner from '../assets/tim-kulig-composer-banner.png';
import inset from '../assets/tim-kulig-profile.jpeg';
import ScreenBanner from "../components/screenBanner";
import ScreenBase from "./ScreenBase";

const AboutScreen: FC = () => {
	const theme = useTheme();

	return (
		<ScreenBase
			fixedChildren={(
				<ScreenBanner
					title="About the Composer"
					subtitle="Timothy Mark Kulig"
					bannerImage={banner}
					insetImage={inset}
					height={200}
					verticalAdjust="70%"
					brightnessAdjust={0.65}
				/>
			)}
			scrollableChildren={(
				<Stack spacing={3} sx={{ maxWidth: '70ch', px: 4, py: 3, color: theme.palette.grey[200], lineHeight: 1.4 }}>
					<Typography variant="body1">
						Tim Kulig started his musical journey at the young age of 12 with nothing but a dream and a Casio CZ-101...
						and he's never looked back.
					</Typography>
					<Typography variant="body1">
						Over the last 3+ decades, Tim has contributed to numerous movies, internet videos, video games and live
						events with his musical pieces.  He is on a journey to publish over 2,000 songs, making them available for
						free under Creative Commons when you give attribution to him in your movies, videos, and internet content.
					</Typography>
					<Typography variant="body1">
						His musical styles vary greatly and include Electronic, Orchestral, DnD, LoFi, Dreamcore, Jazz, Meditation,
						Ambient, Metal, Horror, Comedy, Glitch…just about any style you can imagine!
					</Typography>
					<Typography variant="body1">
						If you're looking for a way to enhance your projects with original and unique sonic soundscapes, Tim has
						what you're looking for!
					</Typography>
					<Button
						variant="outlined"
						size="large"
						href="https://www.imdb.com/name/nm0997280/?ref_=fn_al_nm_1"
						target="_blank"
						sx={{
							maxWidth: 220
						}}
						//startIcon={<FontAwesomeIcon icon={{ prefix: 'fab', iconName: 'imdb' }} />}
					>
						<Typography variant="button">Find me on IMDB!</Typography>
					</Button>
				</Stack>
			)}
		/>
	);
};

export default AboutScreen;
